import { styled } from '@mui/material/styles';
import {
  Box,
  Typography,
  Grid,
  Avatar,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Tooltip,
} from '@mui/material';

export const MainContainer = styled(Box)({
  flexGrow: 1,
});

export const MainHeading = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const ParagraphText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const SectionHeading = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const SubsectionHeading = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const HobbyGrid = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const HobbyIcon = styled(Avatar)({
  width: '50px',
  height: 'auto',
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.1)',
  },
});

export const HobbyTooltip = styled(Tooltip)({});

export const TooltipContent = styled(Typography)({});

export const SpotifyGrid = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const SpotifyIframe = styled('iframe')({
  borderRadius: '12px',
  width: '100%',
  height: '352px',
  border: 'none',
});

export const StyledImageList = styled(ImageList)(({ theme }) => ({
  gap: theme.spacing(1),
}));

export const StyledImageListItem = styled(ImageListItem)({});

export const StyledImageListItemBar = styled(ImageListItemBar)({});

export const ProfilePicture = styled('img')({
  maxWidth: '95%',
  maxHeight: '300px',
  margin: 'auto',
  display: 'block',
});

export const MainPageContainer = styled(Box)({
  alignSelf: 'center',
  justifyContent: 'center',
});
